var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',_vm._g(_vm._b({attrs:{"small":!_vm.large,"color":_vm.active ? 'primary' : null,"text-color":_vm.active ? 'white' : null}},'v-chip',_vm.$attrs,false),_vm.$listeners),[(_vm.icon)?_c('span',[_vm._v(_vm._s(_vm.icon)+" ")]):_vm._e(),_vm._v(_vm._s(_vm.value)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }